module.exports = __webpack_public_path__ + "static/media/8_Luccy_T@3x.db8919f4.jpg";